<template>
    <b-sidebar id="routeSidebar" title="Visualize response">
        <b-textarea v-model="input" rows="20"/>
        <b-button @click="process" variant="success"> Process </b-button>
        <b-button @click="clear" variant="danger"> Clear </b-button>
    </b-sidebar>
</template>

<script>
export default {
    data() {
        return {
            input: "",
        }
    },
    methods: {
        process() {
            this.$emit("input", this.input);
        },
        clear() {
            this.input = "";
        },
    }
}
</script>

<style>

</style>